<template>
  <div class="container">
    <h2>All Users</h2>
    <router-link to="/goals">Goals</router-link>
  </div>
</template>

<style scoped>
  a {
    text-decoration: none;
  }
</style>